window.$ = window.jQuery = require("jquery");

window.Swal = require("sweetalert2");

import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

window.gsap = gsap;
window.ScrollToPlugin = ScrollToPlugin;

require("./dialogs/confirm_dialog");
require("./chat/openai-response");
require("./chat/elevenlabs-streaming");
// require("./chat/did-streaming");
// require("./chat/did-create-video");
// require("./chat/speech-recognition");
require("./chat/microsoft-speech-recognition");
// require("./chat/openai-speech-recognition");

$(function () {
    $("#rd-input-text").on("paste", function (event) {
        event.preventDefault();

        // 取得純文字的內容
        let text = (
            event.originalEvent.clipboardData || window.clipboardData
        ).getData("text");

        // 插入純文字到光標位置
        let selection = window.getSelection();
        if (!selection.rangeCount) return;
        selection.deleteFromDocument();

        // 建立 range 並插入純文字
        let range = selection.getRangeAt(0);
        range.insertNode(document.createTextNode(text));

        // 移動光標到插入文字後
        range.setStartAfter(range.endContainer);
        selection.removeAllRanges();
        selection.addRange(range);
    });

    $("#rd-input-text").on("keydown", function (event) {
        // 檢查是否按下了 Ctrl + Enter
        if ((event.ctrlKey || event.metaKey) && event.key === "Enter") {
            event.preventDefault(); // 防止預設行為（如換行）
            sendButtonEvent();
        }
    });

    $("#rd-send-button").on("click", function (event) {
        sendButtonEvent();
    });

    // {{-- 選擇卡片 --}}
    $(".rd-click-card").on("click", function () {
        // 如果有開啟語音的話，關閉語音收錄
        stopRecognition();

        let chatId = $('meta[name="chat-id"]').attr("content");
        let question = $(this).data("message");
        let agent_id = $('meta[name="chat-user-id"]').attr("content");
        // 2. 再由同一次點擊上下文呼叫 play()
        const audioElement = document.getElementById("audioPlayer");
        audioElement.play(); // Safari/iOS 允許

        $.ajax({
            type: "POST",
            url: $('meta[name="get-card"]').attr("content"),
            data: {
                id: $(this).data("id"),
                chat_id: chatId,
                agent_id: agent_id,
            },
            dataType: "json",
            cache: false,
            success: async function (data, textStatus, xhr) {
                try {
                    setQuestionContent(question);

                    // 1. 先等待音源準備好
                    await window.textToSpeech(stripHTML(data.reply));

                    setAnswerContent(data.reply, data.history_id);

                    // 監聽播放結束事件
                    audioElement.addEventListener(
                        "ended",
                        function () {
                            enableButton();
                            $("#rd-stop-streaming").hide();
                            console.log("播放完成");
                        },
                        { once: true },
                    );

                    $("#rd-stop-streaming").show();

                    console.log("開始播放");
                } catch (err) {
                    // 若還是被擋，提示使用者再次點擊
                    // alert("瀏覽器阻擋自動播放，請再次點擊播放按鈕");
                    console.error(err);
                }
            },
        });
    });

    $("#rd-open-note").on("click", function () {
        if ($(this).hasClass("now")) {
            $(this).removeClass("now");
            $(".did-page").removeClass("open");
        } else {
            $(this).addClass("now");
            $(".did-page").addClass("open");
        }
    });

    $("#rd-new-chat").on("click", function () {
        $.ajax({
            type: "POST",
            url: $('meta[name="new-chat"]').attr("content"),
            dataType: "json",
            cache: false,
            success: function (data, textStatus, xhr) {
                $('meta[name="chat-id"]').attr("content", data.chat_id);
                $("#rd-hello").show();
                $("#rd-card").show();
                $("#msgHistory").html("");
            },
        });
    });

    $("#rd-stop-streaming").on("click", function () {
        const audioElement = document.getElementById("audioPlayer");
        audioElement.pause();
        audioElement.currentTime = 0;
        enableButton();
        $(this).hide();
        console.log("停止播放");
    });
});

window.disableButton = function () {
    $(".chat-tool").addClass("disable");
    $(".chat-tool").find(".btn-box").hide();
    $("#rd-disable-txt").show();
};

window.enableButton = function () {
    $(".chat-tool").removeClass("disable");
    $(".chat-tool").find(".btn-box").show();
    $("#rd-stop-streaming").hide();
    $("#rd-disable-txt").hide();
};

window.showLoading = function () {
    $("#rd-loading").show();
};

window.hideLoading = function () {
    $("#rd-loading").hide();
};

function sendButtonEvent() {
    // 如果有開啟語音的話，關閉語音收錄
    stopRecognition();
    // stopStreamElement.show()
    // 切換按鈕
    disableButton();

    let message = $("#rd-input-text")[0].innerText;
    askOpenAI(message, true, async function (reply, callback) {
        try {
            // 1. 先等待音源準備好
            await window.textToSpeech(reply);

            // 2. 再由同一次點擊上下文呼叫 play()
            const audioElement = document.getElementById("audioPlayer");

            await audioElement.play(); // Safari/iOS 允許
            callback();
            // 監聽播放結束事件
            audioElement.addEventListener(
                "ended",
                function () {
                    enableButton();
                    $("#rd-stop-streaming").hide();
                    console.log("播放完成");
                },
                { once: true },
            );

            $("#rd-stop-streaming").show();
            console.log("開始播放");
        } catch (err) {
            // 若還是被擋，提示使用者再次點擊
            // alert("瀏覽器阻擋自動播放，請再次點擊播放按鈕");
            console.error(err);
        }
    });
}

function stripHTML(input) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(input, "text/html");
    return doc.body.textContent || "";
}
